// eslint-disable-next-line import/prefer-default-export
export const ItemTypes = {
  RESOURCE_GROUP: "resource_group"
};
